import React, { useState } from 'react'
import Accordion from '@mui/material/Accordion'
import AccordionDetails from '@mui/material/AccordionDetails'
import AccordionSummary from '@mui/material/AccordionSummary'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp'
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline'
import EditNoteIcon from '@mui/icons-material/EditNote'
import IconButton from '@mui/material/IconButton'

import SectionFields from './sectionFields'

const SectionDetail = ({
  section,
  setSelectedSection,
  setSectionToEdit,
  setSectionToDelete,
  setFieldToEdit,
  setFieldToDelete,
}) => {
  const [expanded, setExpanded] = useState(false)

  const onDeleteClick = (e) => {
    setSectionToDelete(section)
    e.stopPropagation()
  }

  const onEditClick = (e) => {
    setSectionToEdit(section)
    e.stopPropagation()
  }

  const onAddFieldClick = (e) => {
    setSelectedSection(section)
    setFieldToEdit({ section, field: null })
    e.stopPropagation()
  }

  const handleAccordionChange = (e, isExpanded) => {
    setExpanded(isExpanded)
  }

  return (
    <div>
      <Accordion disableGutters expanded={expanded} onChange={handleAccordionChange}>
        <AccordionSummary expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography sx={{ marginLeft: 1, marginRight: 2 }}>Section: {section.name}</Typography>
              <IconButton onClick={onEditClick}>
                <EditNoteIcon />
              </IconButton>
              <IconButton onClick={onDeleteClick}>
                <RemoveCircleOutlineIcon />
              </IconButton>
            </Box>
            {expanded && (
              <Button variant="contained" size="small" onClick={onAddFieldClick} sx={{ marginLeft: 2 }}>
                Add Field
              </Button>
            )}
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          <SectionFields
            section={section}
            setSelectedSection={setSelectedSection}
            setFieldToEdit={setFieldToEdit}
            setFieldToDelete={setFieldToDelete}
          />
        </AccordionDetails>
      </Accordion>
    </div>
  )
}

export default SectionDetail
